export enum ReviewCycleEventType {
  SCORECARD_GOAL_SETTING = 'SCORECARD_GOAL_SETTING',
  REVIEW_SCORECARD_FEEDBACK = 'REVIEW_SCORECARD_FEEDBACK',
  REVIEW_TEAM_SCORECARDS = 'REVIEW_TEAM_SCORECARDS',
  PROVIDE_FEEDBACK = 'PROVIDE_FEEDBACK',
  SCORECARD_FINALIZATION = 'SCORECARD_FINALIZATION',
  ASSESSMENT_RESULTS = 'ASSESSMENT_RESULTS',
}

export const REVIEW_CYCLE_EVENT_LABELS: Record<ReviewCycleEventType, string> = {
  [ReviewCycleEventType.SCORECARD_GOAL_SETTING]: 'Scorecard Goal Setting',
  [ReviewCycleEventType.REVIEW_SCORECARD_FEEDBACK]:
    'Review your Scorecard and request feedback',
  [ReviewCycleEventType.REVIEW_TEAM_SCORECARDS]:
    'Review Team Scorecards and request feedback',
  [ReviewCycleEventType.PROVIDE_FEEDBACK]: 'Provide feedback',
  [ReviewCycleEventType.SCORECARD_FINALIZATION]:
    'Scorecard finalization deadline',
  [ReviewCycleEventType.ASSESSMENT_RESULTS]:
    'Communication of assessment results',
};
